/* eslint-disable */

import axios from 'axios'
import developmentConfig from './../config/development';
import productionConfig from './../config/production';

import base from './../config/base';
import api_provider from '../providers/api_provider';
import store from '@/store'
import router from '@/router'
import securedWebStorage from '@/main';

const retryAttempts = new Map();
const MAX_RETRIES = 10;

// Interceptor global para incluir company_id
axios.interceptors.request.use(
  (config) => {
    // BFF opaco: el token de sesión viaja en cookie HttpOnly. Se habilita el envío de
    // cookies y se elimina cualquier header Authorization (el front ya no maneja el token).
    config.withCredentials = true;
    if (config.headers) {
      delete config.headers.Authorization;
      if (config.headers.common) delete config.headers.common.Authorization;
    }
    try {
      // Excluir company_id en login o refresh
      const excludedEndpoints = [
        '/bff/back/no-auth/', // login, refresh
      ];

      if (excludedEndpoints.some(endpoint => config.url?.includes(endpoint))) {
        return config;
      }

      // Obtener company_id del store o storage
      const companyId = store.state.id_company || JSON.parse(securedWebStorage.getItem("id_company") || "null");

      if (companyId) {
        if (config.method === "get") {
          config.params = { ...(config.params || {}), company_id: companyId };
        } else if (config.method === "post" || config.method === "put" || config.method === "patch") {
          // Si el cuerpo no es FormData
          if (!(config.data instanceof FormData)) {
            config.data = { ...(config.data || {}), company_id: companyId };
          }
        }
      }
    } catch (err) {
      console.warn("Error agregando company_id al request:", err);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default {
  // -------------------Consultas a bff-------------------
  async postLogin(url, data) {
    try {
      const final_url = base.config.BASE_URL_BFF + `/bff/back/no-auth/`;
      return await axios.post(final_url, { url, data });
    } catch (error) {
      throw error;
    }
  },
  async logout() {
    // Cierra la sesión opaca: el BFF elimina las cookies HttpOnly de auth.
    try {
      await axios.post(base.config.BASE_URL_BFF + `/bff/back/logout/`, {});
    } catch (error) {
      console.error("Error logout:", error);
    }
  },
  async getWsTicket() {
    // Los WebSockets autentican por query string y no pueden leer la cookie HttpOnly.
    // Se pide al BFF (autenticado por cookie) un ticket de un solo uso para el handshake.
    try {
      const { data } = await axios.get(base.config.BASE_URL_BFF + `/bff/ws-ticket/`);
      return data.ticket || "";
    } catch (error) {
      console.error("Error getWsTicket:", error);
      return "";
    }
  },
  async post_file(url, data) {
    try {
      const final_url = base.config.BASE_URL_BFF + '/bff/back/post_file/';
      const access = securedWebStorage.getItem("access");
      const refresh = securedWebStorage.getItem("refresh");
      const checked_access = await api_provider.checkTokens(access, refresh);

      const apiClient = axios.create({
        baseURL: final_url,
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      data.append('url', url);
      return await apiClient.post("", data);
    } catch (error) {
      console.error('error post_file: ', error);
    }
  },
  async post(url, data, query_type = "post", responseType = null, timeout = 30000, reconnect = true) {
    const userKey = securedWebStorage.getItem("id") || "default_user";
    const base_url = base.config.BASE_URL_BFF + `/bff/back/`;

    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            },
            timeout: timeout,
            responseType: responseType || 'json',
            validateStatus: status => status >= 200 && status < 300
        };

        return await axios.post(base_url, { url, data, query_type, responseType}, config);
    } catch (error) {
        if (error.code === "ECONNABORTED" && reconnect) {
          return await this.post(url, data, query_type, responseType, timeout * 2, false);

        } else if (error.response) {
            // Caso de no tener permisos
            if (error.response.status === 403) {
                console.log('Error 403: Forbidden - No tienes permisos para acceder a esta página.');
                router.push({ name: 'ForbiddenError' }).catch(err => console.error('Error al redirigir:', err));

            // Caso de usuario no valido
            } else if (error.response.status === 401) {
                if (!retryAttempts.has(userKey)) retryAttempts.set(userKey, 0);
                const attempts = retryAttempts.get(userKey);
                // console.log("attempts", attempts)
                 if (attempts < MAX_RETRIES) {
                    const reconnect_checked_access = await api_provider.checkTokens( securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
                    const reconnect_config = { headers: { Authorization: `JWT ${reconnect_checked_access}` }, timeout: timeout,};
                    retryAttempts.set(userKey, attempts + 1);
                    console.log(`Reintentando solicitud tras error para el usuario: ${userKey}, intento ${attempts + 1}`);
                    return await axios.post(base_url, { url, data, query_type }, reconnect_config);
                } else {
                    console.log(`Se alcanzó el máximo de reintentos para el usuario: ${userKey}`);
                    retryAttempts.delete(userKey);
                    // se sale del sistema
                    store.commit("clearState");
                    router.push({ name: 'Login' });
                    throw new Error("Máximo de intentos alcanzado. Por favor, inténtalo más tarde.");
                }

            // Otros errores (4xx/5xx): no se reintenta el POST (el refresh de token ya
            // se maneja en el branch 401). Reintentar duplicaría ejecuciones en endpoints
            // no idempotentes; se propaga para que el caller lo maneje en su catch.
            } else {
                throw error;
            }
            // if (error.response.status === 403) {
            //     console.error('Error 403: Forbidden - No tienes permisos para acceder a esta página.');
            //     router.push({ name: 'ForbiddenError' });
            // } else {
            //     const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
            //     const reconnect_config = {
            //       headers: { Authorization: `JWT ${reconnect_checked_access}` },
            //       timeout: timeout,
            //     };
            //     return await axios.post(base_url, { url, data, query_type }, reconnect_config);
            // }
        } else {
            console.error('Error en la solicitud POST sin respuesta:', error);
        }
    }
  },
  async post_bff_back_and_mux(url, url_mux, data) {
    const base_url = base.config.BASE_URL_BFF + `/bff/back_and_mux/`;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.post(base_url, { url, url_mux, data }, config);
    } catch (error) {
        const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
        const reconnect_config = { headers: { Authorization: `JWT ${reconnect_checked_access}`, },};
        return await axios.post(base_url, { url, url_mux, data }, reconnect_config)
        console.error(`error request_bff_back_and_mux `, error);
        throw error;
    }
  },
  /**
   * POST al BFF; si falla, se intenta una vez más. La sesión viaja en la cookie HttpOnly y el
   * BFF la renueva solo (AuthCookieMiddleware): el reintento repite la misma petición.
   *
   * retryOnlyUnauthorized: repetir solo si el BFF rechazó la sesión (401), y no una consulta
   * pesada que terminó en timeout o en error del servidor (la Auditoría y el informe de velocidad).
   */
  async post_bff_with_retry(base_url, body, { retryOnlyUnauthorized = false } = {}) {
    try {
        return await axios.post(base_url, body);
    } catch (error) {
        if (retryOnlyUnauthorized && error?.response?.status !== 401) throw error;
        return await axios.post(base_url, body);
    }
  },
  async post_bff_mux(url, data, { retryOnlyUnauthorized = false } = {}) {
    return api_provider.post_bff_with_retry(base.config.BASE_URL_BFF + `/bff/mux/`, { url, data }, { retryOnlyUnauthorized });
  },
  async post_bff_mux_list(url, url_back, data) {
    const base_url = base.config.BASE_URL_BFF + `/bff/mux/list/`;
    // console.log("post_bff_mux_list", base_url, url, url_back)
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.post(base_url, { url, url_back, data }, config);
    } catch (error) {
        const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
        const reconnect_config = { headers: { Authorization: `JWT ${reconnect_checked_access}`, },};
        return await axios.post(base_url, { url, url_back, data }, reconnect_config)
        console.error(`error request_bff_mux `, error);
        throw error;
    }
  },
  async post_bff_fastapi(url, data, query_type = 'post') {
    const base_url = base.config.BASE_URL_BFF + `/bff/fastapi/`;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.post(base_url, { url, data, query_type }, config);
    } catch (error) {
        const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
        const reconnect_config = { headers: { Authorization: `${reconnect_checked_access}`, },};
        return await axios.post(base_url, { url, data, query_type }, reconnect_config)
        console.error(`error request_bff_fastapi `, error);
        throw error;
    }
  },
  async post_bff_fastapi_list(url, url_back) {
    const base_url = base.config.BASE_URL_BFF + `/bff/fastapi/list/`;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.post(base_url, { url, url_back }, config);
    } catch (error) {
        const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
        const reconnect_config = { headers: { Authorization: `${reconnect_checked_access}`, },};
        return await axios.post(base_url, { url, url_back }, reconnect_config)
        console.error(`error request_bff_fastapi `, error);
        throw error;
    }
  },

  async post_bff_fastapi_file(url, data) {
    const base_url = base.config.BASE_URL_BFF + `/bff/fastapi/post_file/`;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        // Agregar la ruta destino al FormData
        data.append("url", url);

        // Axios enviará multipart/form-data con boundary
        return await axios.post(base_url, data, {
            withCredentials: false,
            headers: {
                "Authorization": `JWT ${checked_access}`,
            }
        });
    } catch (error) {
        console.error("Error en post_bff_fastapi_file:", error);
    }
  },

  async post_bff_fastapi_file2(url, data) {
    const base_url = base.config.BASE_URL_BFF + `/bff/fastapi/post_file/`;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `JWT ${checked_access}`,
            },
        };
        return await axios.post(base_url, { url, data }, config);
    } catch (error) {
        console.error('Error en post_bff_fastapi_file:', error);
        throw error;
    }
  },
  // Listado y descarga de los informes (retryOnlyUnauthorized: ver post_bff_with_retry)
  async post_bff_report(url, data, is_export=false, { retryOnlyUnauthorized = false } = {}) {
    const base_url = base.config.BASE_URL_BFF + (is_export ? `/bff_report/list_export/` : `/bff_report/list/`);
    return api_provider.post_bff_with_retry(base_url, { url, data }, { retryOnlyUnauthorized });
  },
  async post_bff(url, data) {
    const base_url = base.config.BASE_URL_BFF + url;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.post(base_url, data, config);
    } catch (error) {
        const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
        const reconnect_config = { headers: { Authorization: `JWT ${reconnect_checked_access}`, },};
        return await axios.post(base_url, data, reconnect_config)
        console.error(`error post_bff `, error);
        throw error;
    }
  },
  async get_bff(url) {
    const base_url = base.config.BASE_URL_BFF + url;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.get(base_url, config);
    } catch (error) {
        const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
        const reconnect_config = { headers: { Authorization: `JWT ${reconnect_checked_access}`, },};
        return await axios.get(base_url, reconnect_config)
        console.error(`error get_bff `, error);
        throw error;
    }
  },
  async post_bff_file(url, data) {
    const base_url = base.config.BASE_URL_BFF + url;
    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const apiClient = axios.create({
        baseURL: base_url,
        withCredentials: true,
        headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        return await apiClient.post("", data);
    } catch (error) {
        console.error('Error en post_bff_fastapi_file:', error);
        // throw error;
    }
  },
  // -------------------------------------------------------------------------------
  async checkTokens() {
    // BFF opaco: el access token vive en cookie HttpOnly y el BFF renueva la sesión de
    // forma transparente. Se conserva la función por compatibilidad con sus llamadores;
    // ya no maneja tokens ni expiración en el cliente.
    return null;
  },
  async panel_control_tag(data) {

    let base_url = base.config.BASE_URL_BFF + `/bff_report/panel_control_tag/`;

    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.post(base_url, { data }, config);

    } catch (error) {
        // El reintento repite la misma llamada. Antes mandaba un `url_back` que esta
        // funcion no recibe, asi que cualquier fallo de red terminaba en un
        // ReferenceError en vez de reintentar.
        const reconnect_config = { headers: { 'Content-Type': 'application/json' } };
        return await axios.post(base_url, { data }, reconnect_config);
    }

  },

    async list_control_tag(url_back, data) {

    let base_url = base.config.BASE_URL_BFF + `/bff_report/list_control_tag/`;

    try {
        const access = securedWebStorage.getItem("access");
        const refresh = securedWebStorage.getItem("refresh");
        const checked_access = await api_provider.checkTokens(access, refresh);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `JWT ${checked_access}`,
            }
        };

        return await axios.post(base_url, { url_back, data }, config);

    } catch (error) {
        const reconnect_checked_access = await api_provider.checkTokens(securedWebStorage.getItem("access"), securedWebStorage.getItem("refresh"));
        const reconnect_config = { headers: { Authorization: `${reconnect_checked_access}`, },};
        return await axios.post(base_url, { url_back, data }, reconnect_config)
        console.error(`error request_bff_back_and_mux `, error);
        throw error;
    }

  },

};